import React from 'react';
import { cva } from 'class-variance-authority';
import ErrorMessage from '@/components/common/ErrorMessage';
import { cn } from '@/lib/utils';

const inputVariants = cva(
  'flex w-full rounded-lg border px-4 border-[#D9DBE9] text-secondary outline-0 disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        default: '',
        outline: '',
      },
      size: {
        default: 'h-12 px-4',
        sm: 'h-10 rounded-md px-4 text-sm',
        lg: 'h-11 rounded-md px-4 text-base',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

const Input = React.forwardRef(
  (
    {
      className,
      groupClassName,
      size,
      variant,
      type,
      labelClassName,
      labelStyleClassName,
      labelText,
      errorType,
      errorData,
      customMessage,
      id,
      // 🔥 NEW: allow custom classes for the input element
      inputClassName,
      ...props
    },
    ref
  ) => {
    return (
      <div className={cn('form-input-item', groupClassName)}>
        {labelText && (
          <label
            htmlFor={id}
            className={cn(
              labelStyleClassName
                ? labelStyleClassName
                : 'text-sm capitalize mb-1 text-heading inline-block',
              labelClassName
            )}
          >
            {labelText}
          </label>
        )}
        <input
          type={type}
          ref={ref}
          className={cn(
            inputVariants({ size, className, variant }),
            type === 'file' && 'db-field-control',
            errorType && 'invalid',
            // 🔥 make sure this comes LAST so it overrides text-secondary
            inputClassName
          )}
          {...props}
        />
        {errorType && (
          <ErrorMessage
            errorType={errorType}
            errorData={errorData}
            customMessage={customMessage}
          />
        )}
      </div>
    );
  }
);

export { Input, inputVariants };
